import styled from 'styled-components'
import SectionLabel from '@components/SectionLabel/SectionLabel'
import { BLACK, BLUE, NEUTRAL_100, PALE_BLUE } from '@styles/colors'
import { INTER } from '@styles/fonts'
import { safeAreaInset } from '@lib/telegram'

export const Container = styled.div`
    width: 100%;
    height: 100vh;
    display: flex;
    flex-direction: column;
    overflow: hidden;
`

export const ContentContainer = styled.div`
    padding: 16px 12px;
    overflow: auto;
    flex: 1;
`

export const DetailLabel = styled(SectionLabel)`
    display: block;
    margin-bottom: 8px;
`

export const DetailBox = styled.div`
    border: 1px solid #E4E7ED;
    padding: 16px 14px;
    border-radius: 16px;
    margin-top: 16px;
    display: flex;
    flex-direction: column;
    gap: 10px;
`

export const ButtonContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    padding: 16px 12px 24px 12px;
    padding-bottom: ${safeAreaInset().bottom || 24}px;
`

export const RedemptionCard = styled.div`
    background-color: ${PALE_BLUE};
    border: 1px solid ${NEUTRAL_100};
    border-radius: 12px;
    padding: 16px 14px;
    margin-bottom: 16px;
    margin-top: 8px;
`

export const RedemptionStatusRow = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 16px;
`

export const RedemptionStatusText = styled.span`
    color: ${BLACK};
    font-family: ${INTER.regular};
    font-size: 13px;
`

export const Divider = styled.div`
    width: 100%;
    height: 1px;
    background-color: ${NEUTRAL_100};
    margin: 16px 0;
`

export const RedemptionDetailsRow = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
`

export const RedemptionDetailsText = styled.span`
    color: ${BLUE};
    font-family: ${INTER.semiBold};
    font-size: 13px;
`

export const FieldRowsContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 6px;
`

export const ButtonIconContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding-bottom: 4px;
`

export const ButtonContentWrapper = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 8px;
`

export const ButtonGroupContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: 16px;
`

export const HorizontalButtonGroup = styled.div`
    display: flex;
    flex-direction: row;
    gap: 16px;
`

export const AlertContainer = styled.div`
    margin-top: 12px;
    display: flex;
    flex-direction: column;
    gap: 8px;
`